import { createSlice } from "@reduxjs/toolkit";
import { query } from "../../services/object";

export const corporateArtCollectionsSlice = createSlice({
  // Slice name, this should be always as page name.
  name: "corporateArtCollections",

  // Initial state for the slice
  initialState: {
    data: {},
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },

  // Reducers will mutate the state, put all the state mutation method over here
  reducers: {
    initialize: (state, action) => {
      state.data = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
    loading: (state, action) => {
      state.status = action.payload ? "loading" : "succeeded";
    },
    initialLoading: (state, action) => {
      state.status = action.payload ? "initalLoading" : "succeeded";
    },
    error: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export default corporateArtCollectionsSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } =
  corporateArtCollectionsSlice.actions;

// Public Selectors
export const selectCorporateArtCollectionsData = (state) =>
  state.corporateArtCollections.data;
export const selectCorporateArtCollectionsStatus = (state) =>
  state.corporateArtCollections.status;
export const selectCorporateArtCollectionsError = (state) =>
  state.corporateArtCollections.error;

export const initializeAsync = (props) => async (dispatch) => {
  dispatch(initialLoading(true));
  let arts = await query("artLocation", "getAllArtLocationRecords");
  if (arts.isSuccess) {
    dispatch(initialize({ records: arts.data }));
  }
};
